<template>
  <div class="warpper">
    <div class="page-title line-height">机构动态</div>
    <div class="flex flex-direction">
      <div class="item-notice flex align-center" v-for="(item,index) in lists" :key="index"
           @click="toActiveDetail(item.id)">
        <el-image class="image flex-shrink" fit="cover"  :src="item.thumb"></el-image>
        <div class="flex flex-direction justify-between flex-sub margin-left-sm overflow-hidden">
          <div class="title ovHide">{{ item.title }}</div>
          <div class="content ovHide2">
            {{ item.content }}
          </div>
          <div class="time">{{ item.create_time }}</div>
        </div>
      </div>
    </div>
    <el-pagination
      v-if="lists.length>0"
      class="page-all margin-top"
      background
      @current-change="init"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
      <empty v-if="lists.length === 0" :type="1"/>
      <active-detail-dialog :aid="cur_aid" :detailDialogVisible="detailDialogVisible"
                          @watchState="watchState"></active-detail-dialog>
  </div>
</template>

<script>
import {getActives} from '@/api/member'
import ActiveDetailDialog from "@/components/ActiveDetailDialog.vue";
import {reg_html} from '@/utils/rules'

export default {
  components: {ActiveDetailDialog},
  name: "notice",
  data() {
    return {
      lists: [],
      page: 1,
      limit: 10,
      total: 0,
      cur_aid: 0,
      detailDialogVisible: false
    }
  },
  created() {
    this.$emit('setIndex', [2], '机构动态')
    this.init()
  },
  computed: {},
  methods: {
    //  页面加载时请求
    async init() {
      let _data = await getActives('', this.page, this.limit)
      if (_data.status === 200) {
        _data.data.data.map(item => {
          item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, "")
        })
        this.lists = _data.data.data
        this.total = _data.data.total
      }
    },
    toActiveDetail(id) {
      this.cur_aid = id
      this.detailDialogVisible = true;
    },
    watchState() {
      this.detailDialogVisible = false;
    },
  }

}
</script>

<style scoped lang="scss">
.warpper {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;

  .item-notice {
    width: 100%;
    min-height: 159px;
    background-color: #f3f7fb;
    border-radius: 10px;
    margin-top: 20px;
    padding: 11px 20px;
    cursor: pointer;

    .title {
      font-size: 22px;
      line-height: 22px;
      color: #0a2240;
    }

    .content {
      width: 100%;
      font-size: 16px;
      line-height: 20px;
      color: #7889a4;
      margin-top: 19px;
    }

    .image {
      width: 154px;
      height: 116px;
      border-radius: 10px;
    }

    .time {
      font-size: 14px;
      color: #7889a4;
      margin-top: 19px;
    }
  }
}

</style>